<template lang="pug">

  transition(
    v-on:enter="enter"
    v-on:leave="leave"
    appear
    )

    #rating-five.content-section

      article.content-inner

        h1 How does a 5-star car crash? 

        p No one expects to crash, but if you do, you’ll be grateful to be in a 5-star safety rated car.
        
        p To earn this rating, every feature of the car must be designed to preserve the 
          em survival bubble 
          | that cocoons each occupant to protect the body. On impact, the vehicle will crumple and absorb the energy in a way that maintains a safe space around you. Interior features will react to protect you too; pedal boxes will collapse and active head restraints will diffuse impact. 
          strong A 5-star car is among the safest on the road.
        
        h3 Next time you are buying, look for the highest star rating in your price range.

</template>

<script>

import { PATHS } from 'src/config/app'
import BaseContentPageMixin from '@/components/content-pages/mixins/BaseContentPage'

export default {

  name: PATHS.RATING_FIVE,

  components: { },

  mixins: [
    BaseContentPageMixin
  ],

  data() {
    return { }
  },

  computed: {},

  mounted() {},

  beforeDestroy() {},

  methods: {

  },

  watch: {},

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

</style>
